//show full long reviews
document.addEventListener('DOMContentLoaded', function () {
    let container = document.querySelector('.card-body');
    if (!container) return;

    let texts = container.querySelectorAll('.review_column');

    texts.forEach(function(text) {
        if (text.clientHeight > 45) {
            text.classList.add('review_column--long')
        }
    })

    container.onclick = function(event) {
        let btn = event.target.closest('.widereview-hide-text-overlay');
        if (!btn) return;
        if (!container.contains(btn)) return;

        let parent = btn.closest('.review_column');
        parent.classList.add('review_column--full');
    };
});


//popups with review conditions in dashboard
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        let container = document.querySelector('.card');
        if (!container) return;
        let popups = document.querySelectorAll('.btn-review-conditions__wrapper');
        let mainPopupBtn = document.getElementById('mass_update_status');
        if (!mainPopupBtn) return;

        if (!mainPopupBtn) return;

        container.onclick = function(event) {
            let btn = event.target.closest('.btn-review-conditions');
            if (!btn) return;
            if (!container.contains(btn)) return;
            showPopupConditions(btn);
        };

        mainPopupBtn.onclick = function (event) {
            document.getElementById('modal_review_conditions').classList.toggle('hidden');
        }

        function showPopupConditions (btn) {
            let currentPopup = btn.querySelector('.btn-review-conditions__wrapper');

            popups.forEach(function (popup) {
                if (popup !== currentPopup) {
                    popup.classList.remove('btn-review-conditions__wrapper--active');
                }
            })

            if (currentPopup) {
                currentPopup.classList.toggle('btn-review-conditions__wrapper--active');
            }
            if (document.getElementById('modal_review_conditions').classList.contains('hidden') === false) {
                closeMainPopupConditions();
            }
        }

        document.addEventListener("click", function(event) {
            if (event.target === mainPopupBtn) {
                closePopupConditions();
                return;
            }

            if (event.target.closest('.btn-review-conditions')) {

                return;
            }

            if (event.target.closest('.btn-review-conditions__wrapper--active')) {
                closeMainPopupConditions();
                return;
            }

            closeMainPopupConditions();
            closePopupConditions();
        });

        function closeMainPopupConditions() {
            document.getElementById('modal_review_conditions').classList.add('hidden');
        }

        function closePopupConditions() {
            popups.forEach(function (popup) {
                if (popups.length) {
                    popup.classList.remove('btn-review-conditions__wrapper--active');
                }
            })
        }
    });
}) ();

//create loader
export function createLoader () {
    let loader = document.createElement('div');
    loader.classList.add('widereview-loader');
    return loader;
}

export function addRateParentFlexWrap() {
    let rates = document.querySelectorAll('.widereview-rate');
    rates.forEach(function (node){
        let parent = node.parentElement;
        let parentStyle = window.getComputedStyle(parent);
        if (parentStyle.display === "flex") {
            node.parentElement.style.flexWrap = "wrap";
        }
    });
}

export function addOverflowForminiParent() {
    let parent = document.querySelector('.product-form__buy-buttons');
    if (!parent) return;
    let miniSliderContainer = document.querySelector('.widereview-mini');
    if (!miniSliderContainer) return;
    parent.style.overflow = 'hidden';
}
